module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "topbar",
    style: (_vm.navbarStyle)
  }, [(_vm.remarks) ? _c('a', {
    staticClass: "navbar-phone",
    attrs: {
      "href": ("tel: " + _vm.remarks)
    }
  }, [_vm._v(_vm._s(_vm.remarks))]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-btn",
    attrs: {
      "to": "/borrow/city"
    }
  }, [_vm._v(_vm._s(_vm.cityName))])], 1), _vm._v(" "), _c('scroller', {
    ref: "scroller",
    attrs: {
      "on-scroll": _vm.onScroll
    }
  }, [_c('div', {
    ref: "swiper",
    staticClass: "swiper-container",
    staticStyle: {
      "height": "3.06rem"
    }
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.banners), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "swiper-slide"
    }, [_c('a', {
      staticClass: "slide-link",
      style: ({
        backgroundImage: 'url(' + (item.url || './banner.jpg') + ')'
      }),
      attrs: {
        "href": item.src,
        "target": item.target
      }
    }, [_c('img', {
      staticClass: "item",
      attrs: {
        "src": item.url
      }
    })])])
  })), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  })]), _vm._v(" "), _c('div', {
    staticClass: "section-title"
  }, [_c('h4', {
    staticClass: "caption"
  }, [_vm._v("热门产品")]), _vm._v(" "), _c('p', {
    staticClass: "link-group"
  }, _vm._l((_vm.links), function(link, index) {
    return _c('a', {
      key: index,
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onLinkClick(index)
        }
      }
    }, [_vm._v(_vm._s(link.name))])
  })), _vm._v(" "), _c('router-link', {
    staticClass: "icon",
    attrs: {
      "to": "/borrow/explain"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-padded"
  }, [_c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.proList), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "list-item",
      on: {
        "click": function($event) {
          _vm.onItemClick(index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.picUrl
      }
    })])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasmore),
      expression: "hasmore"
    }],
    staticClass: "loadmore",
    on: {
      "click": _vm.loadmore
    }
  }, [_c('a', {
    staticClass: "btn-more",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("加载更多")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.consultantList.length > 0),
      expression: "consultantList.length > 0"
    }],
    staticClass: "consultants-wrap"
  }, [_c('div', {
    staticClass: "consultants-swiper"
  }, [_c('div', {
    ref: "consultantSwiper",
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_vm._l((_vm.consultantList), function(consultant, index) {
    return _c('div', {
      key: index,
      staticClass: "swiper-slide"
    }, [_c('div', {
      staticClass: "consultant-content"
    }, [_c('router-link', {
      attrs: {
        "to": ("consultant/articlelist/" + (consultant.uid))
      }
    }, [_c('div', {
      staticClass: "consultant-head"
    }, [_c('img', {
      attrs: {
        "src": consultant.logoUrl,
        "alt": "consultant.name"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "consultant-desc"
    }, [_c('h3', [_c('span', {
      staticClass: "consultant-name"
    }, [_vm._v(_vm._s(consultant.name))]), _c('span', {
      staticClass: "consultant-job"
    }, [_vm._v(_vm._s(consultant.profession))])]), _vm._v(" "), _c('p', {
      staticClass: "skilled"
    }, [_vm._v(_vm._s([].concat(consultant.skills).join(' | ')))]), _vm._v(" "), _c('div', {
      staticClass: "consult-contact"
    }, [_c('div', {
      staticClass: "contact-item"
    }, [_c('span', {
      staticClass: "iconfont"
    }, [_vm._v("")]), _c('span', {
      staticClass: "decimal"
    }, [_vm._v(_vm._s(consultant.phone))])]), _vm._v(" "), _c('div', {
      staticClass: "contact-item"
    }, [_c('span', {
      staticClass: "iconfont"
    }, [_vm._v("")]), _c('span', {
      staticClass: "decimal"
    }, [_vm._v(_vm._s(consultant.wechat))])])])])]), _vm._v(" "), _c('div', {
      staticClass: "consultant-article"
    }, [(consultant.articles[0]) ? _c('div', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.$router.push(("/consultant/article/" + (consultant.articles[0].author) + "?id=" + (consultant.articles[0].id)))
        }
      }
    }, [_c('span', {
      staticClass: "tag"
    }, [_vm._v(_vm._s(_vm.copyRightMap.get(consultant.articles[0].copyright)))]), _vm._v(" "), _c('p', {
      staticClass: "title"
    }, [_vm._v(_vm._s(consultant.articles[0].title))]), _vm._v(" "), _c('span', {
      staticClass: "time text-right"
    }, [_vm._v(_vm._s(consultant.articles[0].auditDate))])]) : _vm._e()])], 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('router-link', {
    staticClass: "consultant-more",
    attrs: {
      "to": "/consultant",
      "tag": "div"
    }
  }, [_c('span', {
    staticClass: "more-zh"
  }, [_vm._v("查看更多")]), _vm._v(" "), _c('img', {
    staticClass: "more-en decimal",
    attrs: {
      "src": require("../../../static/images/MORE.png"),
      "alt": "",
      "width": "47px"
    }
  })])], 1)], 2)])])]), _vm._v(" "), _c('router-link', {
    staticClass: "about",
    attrs: {
      "tag": "div",
      "to": "/about"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/about.png"
    }
  })])], 1)]), _vm._v(" "), _c('spinner', {
    attrs: {
      "show": _vm.loading
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "topbar-title"
  }, [_c('span')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-258f2114!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/borrow/borrow.vue
// module id = 339
// module chunks = 1